import Enum from 'enum';

export enum ERuntimeType {
    one = 2,
    half = 1,
}

export const BookingRuntimeTypeEnum = new Enum({
    30: 1,
    60: 2,
});